import i18n from 'i18next';
import moment from 'moment';
import sprintf from 'i18next-sprintf-postprocessor';
import languageDetector from 'i18next-browser-languagedetector';

/*
 * i18n Initialization singleton
 *
 * @param resources object
 *
 * A static Object passed per-application that encompasses language, namespace, and translations.
 * Example:
 * {
 *  en: {
 *  exampleNamesapce: require('locales/en/translations.json')
 *  },
 *  ...
 * }
 */
export default function(resources, namespace='defaultNamespace') {
  return (function(resources, namespace) {
    var instance = null;

    function createInstance(resources, namespace) {
      return setup_i18n(resources, namespace);
    }
    return {
      getInstance: function () {
        if (!instance) {
          instance = createInstance(resources, namespace);
        }
        return instance;
      }
    }
    function setup_i18n(resources, namespace) {
      const newInstance = i18n.createInstance();

      newInstance
        .use(sprintf)
        .use(languageDetector)
        .init({
          resources: {},
          partialBundledLanguages: true,
          fallbackLng: ['en'],
          fallbackNS: ['defaultNamespace'],
          ns: [namespace],
          defaultNS: namespace,
          debug: false,
          keySeparator: '>',
          nsSeparator: '|',
          returnObjects: true,
          returnEmptyString: false,
          interpolation: {
            escapeValue: false,
            formatSeparator: ',',
            format: function(value, format) {
              if (format === 'uppercase') return value.toUpperCase();
              return value;
            }
          },
          detection: {
            // order and from where user language should be detected
            order: ['querystring', 'htmlTag', 'cookie', 'navigator'],
            // keys or params to lookup language from
            lookupQuerystring: 'locale',
            lookupCookie: 'locale'
          }
        });
      moment.locale(i18n.language);
      return newInstance;
    }
  }(resources, namespace));
}
